<template>
	<BaseCmsPage v-slot="{page}">
		<BaseTagTags v-slot="{items}">
			<ul v-if="items?.length">
				<li v-for="item in items" :key="item.id">
					<NuxtLink :to="item.url_without_domain">{{ item.title }}</NuxtLink>
				</li>
			</ul>
		</BaseTagTags>
	</BaseCmsPage>
</template>
